import * as yup from "yup";

export const customerInteractionReviewSchema = (form) =>
  yup.object().shape({
    enteredVenue: yup
      .boolean()
      .required(
        "Please confirm if the customer has entered the venue since the interaction.",
      ),
    venueEnterCountId: form.enteredVenue
      ? yup
        .number()
        .required(
          "Please select how many times the customer visited the venue since the interaction.",
        )
      : yup.number().notRequired(),
    venueEnterTimeId: form.enteredVenue
      ? yup
        .string()
        .required(
          "Please select how long the customer spends in the venue on average.",
        )
      : yup.string().notRequired(),
    behaviourChanged: yup
      .boolean()
      .required(
        "Please confirm if the customer's playing habits have changed since the interaction.",
      ),
    behaviourComments: form.behaviourChanged
      ? yup
        .string()
        .required("Please describe how the customer's habits have changed.")
      : yup.string().notRequired(),
    atRisk: yup
      .boolean()
      .required(
        "Please confirm if you believe the customer is at risk of gambling harm.",
      ),
    atRiskMeasures: form.atRisk
      ? yup
        .string()
        .required(
          "Please describe what measures have been taken to reduce the customer's risk of gambling harm.",
        )
      : yup.string().notRequired(),
    anotherReview: yup
      .boolean()
      .required("Please confirm if you'd like to set another date for review."),
    nextReviewDate: form.anotherReview
      ? yup.date().required("Please select a date for the customer's review")
      : yup.date().notRequired(),
    barCustomer: yup
      .boolean()
      .required(
        "Please confirm if you'd like to bar this customer from the venue.",
      ),
  });
